import ApiInstance from './api'

const ApiSaoPaulo = new ApiInstance('https://smart-api.smartnx.io', 'mT8ou31XBBFB7nU6MX6fprtBhadLsN0+IiZZtR2/28z7rhZNONqmxgQunEjvXZz2hqzGaKZHvq/WfgCng59Wrkpp2xaEV8LtZf1cW2/DSeM=')
const ApiPacheco = new ApiInstance('https://smart-api.smartnx.io', 'fDbrS7kulX/8eOymP8kIgNAxwML4XIolNx/wj1mHN2Lr11vlVTmOFvJn8IFuIictfePj9i8Rzi1kGSe/hXfBH2U9TByqseT2VH+S6C0wvG0=')

class Vtex {
  getFormatedOrders(numberOrder) {
  const apiSaoPaulo = [
    `v${numberOrder}dgsp-01`,
    `v${numberOrder}dgsp-02`,
    `v${numberOrder}dgsp-03`,
  ]
  const apiPacheco = [
    `v${numberOrder}dgpc-01`,
    `v${numberOrder}dgpc-02`,
    `v${numberOrder}dgpc-03`,
  ]
    return [apiSaoPaulo, apiPacheco]
  }
  
  async getOrder(number, cpf) {
      const [ordersSaoPaulo, ordersPacheco] = this.getFormatedOrders(number)
      const respsSaoPaulo = await Promise.all(ordersSaoPaulo.map(async (formatedNumber) =>  await ApiSaoPaulo.get(`api/v1/vtex/orders/${formatedNumber}`, { company_id: "6" })))
      const respsPacheco = await Promise.all(ordersPacheco.map(async (formatedNumber) =>  await ApiPacheco.get(`api/v1/vtex/orders/${formatedNumber}`, { company_id: "8" })))
      const respsOk = this.filterSuccessOrders([...respsSaoPaulo, ...respsPacheco], cpf)
      return respsOk
  }

  
  filterSuccessOrders(orders, cpf) {
    const formatedCpf = cpf.split('.').join('').replace('-','')
    let successOrders = orders.filter((order) => !!order.data)
    // verificar se pode trazer todos os status
    // successOrders = successOrders.filter((order) => order.data.status === 'invoiced')
    successOrders = successOrders.filter((order) => String(order.data.clientProfileData.document) === String(formatedCpf))
    return successOrders
  }

  
  async getOrderByCpf(cpf) {
    const resp = await ApiPacheco.get(`api/v1/vtex/clients/${cpf}/orders/last`, { company_id: "8" })
    const resp2 = await ApiSaoPaulo.get(`api/v1/vtex/clients/${cpf}/orders/last`, { company_id: "6" })
    return [resp, resp2]
  }
} 

const VtexInstance = new Vtex()
export default VtexInstance